import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const getProjectPackages = (projectId) => Axios.post('/packages/search', { projectID: projectId, sentOnly: false });

const useProjectPackages = (projectId) => {
    return useQuery({
        queryKey: ['projectPackages', projectId],
        queryFn: () => getProjectPackages(projectId),
        staleTime: 60000,
        cacheTime: 60000,
        retry: false,
        enabled: projectId ? true : false,
    });
};

const forceReloadProjectPackages = (projectId) => {
    return queryClient.invalidateQueries({ queryKey: ['projectPackages', projectId] });
};

export { useProjectPackages, forceReloadProjectPackages };
